import {
  AMBIENT_SCRIBE_STATUS_COMPLETED,
  AMBIENT_SCRIBE_STATUS_PAUSED
} from "features/medical-scribe/medical-scribe-constants";
import type {
  ScribeAudioChunk,
  ScribeTranscriptionChunk
} from "services/types/ambient-scribe.type";

export function getAudioChunkText(chunks: ScribeTranscriptionChunk[]): string {
  return chunks.map((c) => c.text).join(" ").trim();
}

export function hasTranscribedAudioChunks(chunks: ScribeAudioChunk[]): boolean {
  return chunks.some(
    (chunk) => getAudioChunkText(chunk.transcription_chunks).length > 0
  );
}

export const DELETE_CONFIRM_IRREVERSIBLE =
  "This recording will be permanently deleted. This cannot be undone.";

export const DELETE_CONFIRM_COMPLETED_EXTRA =
  "The scribe moves to Paused. The Scribe and Summary won't stay final until you click Complete Scribe to regenerate from the remaining recordings.";

export function canDeleteAudioRecording(
  status: number | undefined,
  chunkCount: number
): boolean {
  const hasMultipleChunks = chunkCount > 1;
  const isPaused = status === AMBIENT_SCRIBE_STATUS_PAUSED;
  const isCompleted = status === AMBIENT_SCRIBE_STATUS_COMPLETED;
  return hasMultipleChunks && (isPaused || isCompleted);
}

export function getDeleteDisabledReason(
  status: number | undefined,
  chunkCount: number
): string | undefined {
  if (chunkCount <= 1) {
    return "Cannot delete the last audio recording";
  }
  const isPaused = status === AMBIENT_SCRIBE_STATUS_PAUSED;
  const isCompleted = status === AMBIENT_SCRIBE_STATUS_COMPLETED;
  if (!isPaused && !isCompleted) {
    return "Deletion is only available for paused or completed scribes";
  }
  return undefined;
}

export function scribeNeedsEditBeforeDelete(
  status: number | undefined
): boolean {
  return status === AMBIENT_SCRIBE_STATUS_COMPLETED;
}

export function hasExtendedDeleteConfirmWarning(needsEdit: boolean): boolean {
  return needsEdit;
}
